import { ComponentsOverrides, ComponentsProps, Theme } from "@mui/material";

type MuiTextField = {
  styleOverrides: ComponentsOverrides<Theme>["MuiTextField"];
  defaultProps?: ComponentsProps["MuiTextField"];
};

const muiTextField: MuiTextField = {
  defaultProps: {
    variant: "filled",
  },
  styleOverrides: {},
};

export default muiTextField;
